const state = {
  dismissedList: [],
  clearedList: [],
};

const getters = {
  getBroadcastDismissedList: (state) => state.dismissedList,
  getBroadcastClearedList: (state) => state.clearedList,
};

const mutations = {
  setBroadcastDismissedList(state, data) {
    state.dismissedList = data;
  },
  setBroadcastClearedList(state, data) {
    state.clearedList = data;
  },
};

const actions = {
  async deleteBroadcast({dispatch}, notificationId) {
    const res = await dispatch('api/nav/adminRemoveBroadcast', notificationId);
    if(res.success) {
      dispatch('popups/show/success/deleting', 'Broadcast')
      dispatch('analytics/deleteBroadcast', notificationId)
    } else {
      dispatch('popups/show/error/deleting', 'This broadcast')
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
